export default __webpack_public_path__ + "static/media/locations-calendar-details.04b717f3.png";